import { useParams } from 'react-router-dom';

export const useCompanyIdFromUrl = () => {
  const { companyID } = useParams();

  return companyID;
};
